import { render, staticRenderFns } from "./trendDlt.vue?vue&type=template&id=f1ffd0d6"
import script from "./trendDlt.vue?vue&type=script&lang=js"
export * from "./trendDlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports